/**
 * @fileoverview Maps validation error codes to i18n messages.
 */

const VALIDATION_ERROR_RESOLVERS = {
  FIELD_REQUIRED: (t) => t("errors.validation.FIELD_REQUIRED"),
  FIELD_TOO_LONG: (t, validation) =>
    t("errors.validation.FIELD_TOO_LONG", {
      maxLength: validation.maxLength,
      currentLength: validation.currentLength,
    }),
  FIELD_TOO_SHORT: (t, validation) =>
    t("errors.validation.FIELD_TOO_SHORT", {
      minLength: validation.minLength,
      currentLength: validation.currentLength,
    }),
  FIELD_INVALID_PATTERN: (t, validation) =>
    t(`errors.validation.${validation.patternDescription}`),
  INVALID_DATE: (t) => t("errors.validation.INVALID_DATE"),
  FUTURE_DATE_NOT_ALLOWED: (t) => t("errors.validation.FUTURE_DATE_NOT_ALLOWED"),
  MINIMUM_AGE_REQUIRED: (t) => t("errors.validation.MINIMUM_AGE_REQUIRED"),
  MAXIMUM_AGE_EXCEEDED: (t) => t("errors.validation.MAXIMUM_AGE_EXCEEDED"),
  PHONE_MUST_BE_10_DIGITS: (t) =>
    t("errors.validation.PHONE_MUST_BE_10_DIGITS"),
  PHONE_EXTENSION_MAX_5_DIGITS: (t) =>
    t("errors.validation.PHONE_EXTENSION_MAX_5_DIGITS"),
  INVALID_EXPERIENCE_FORMAT: (t) =>
    t("errors.validation.INVALID_EXPERIENCE_FORMAT"),
  EXPERIENCE_TOO_HIGH: (t) => t("errors.validation.EXPERIENCE_TOO_HIGH"),
  EXPERIENCE_CANNOT_BE_NEGATIVE: (t) =>
    t("errors.validation.EXPERIENCE_CANNOT_BE_NEGATIVE"),
  NEGATIVE_NUMBERS_NOT_ALLOWED: (t) =>
    t("errors.validation.NEGATIVE_NUMBERS_NOT_ALLOWED"),
  INVALID_FORMAT_OR_SYMBOLS: (t) =>
    t("errors.validation.INVALID_FORMAT_OR_SYMBOLS"),
  DECIMAL_NUMBERS_NOT_ALLOWED: (t) =>
    t("errors.validation.DECIMAL_NUMBERS_NOT_ALLOWED"),
};

export const getValidationErrorMessage = (t, validation) => {
  if (validation.isValid) {
    return null;
  }

  const resolver = VALIDATION_ERROR_RESOLVERS[validation.error];
  if (resolver) {
    return resolver(t, validation);
  }

  return t("errors.validation.FIELD_REQUIRED");
};
